module.exports = __webpack_public_path__ + "media/en_au_s4_Madeline.44332006.oga";